export const privateRoles = ["PVT_USER_ACCESS"];
export const tcRoles = ["TC_ADM_ACCESS", "TC_USER_ACCESS"];
export const adminRoles = ["FULL_ACCESS"];
export const adminMenuRoles = ["ST_ADM_ACCESS", "FULL_ACCESS", "TC_ADM_ACCESS"];
export const stateAdminRole = ["ST_ADM_ACCESS"];
